/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WebApiModelsEnumerationTypesCustomListType = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;
export type WebApiModelsEnumerationTypesCustomListType = typeof WebApiModelsEnumerationTypesCustomListType[keyof typeof WebApiModelsEnumerationTypesCustomListType];


export function WebApiModelsEnumerationTypesCustomListTypeFromJSON(json: any): WebApiModelsEnumerationTypesCustomListType {
    return WebApiModelsEnumerationTypesCustomListTypeFromJSONTyped(json, false);
}

export function WebApiModelsEnumerationTypesCustomListTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiModelsEnumerationTypesCustomListType {
    return json as WebApiModelsEnumerationTypesCustomListType;
}

export function WebApiModelsEnumerationTypesCustomListTypeToJSON(value?: WebApiModelsEnumerationTypesCustomListType | null): any {
    return value as any;
}

